import BaseApi from '@/api/controller/base';
import { BusinessReferralPayoutTO, ClientReferralPayoutTO } from '@/model';

const REFERRAL_API_URL = 'referral/';

class ReferralApi extends BaseApi {
  constructor() {
    super(REFERRAL_API_URL);
  }

  getUnassignedCodes() {
    return this.api.get('unassigned');
  }

  newReferral(referralTO) {
    return this.api.post('', referralTO);
  }

  /**
   * @param {BusinessReferralPayoutTO} payoutTO
   */
  payBusinessReferral(payoutTO) {
    if (!(payoutTO instanceof BusinessReferralPayoutTO)) {
      throw new Error("'payoutTO' must be an instance of 'BusinessReferralPayoutTO'");
    }

    return this.api.post('payBusinessReferral', payoutTO);
  }

  /**
   * @param {BusinessReferralPayoutTO} payoutTO
   * @param {string} accessToken
   */
  payBusinessReferralWithApproval(payoutTO, accessToken) {
    if (!(payoutTO instanceof BusinessReferralPayoutTO)) {
      throw new Error("'payoutTO' must be an instance of 'BusinessReferralPayoutTO'");
    }

    return this.api.post('payBusinessReferral', payoutTO, {
      headers: {
        Authorization: `Bearer ${accessToken.token}`,
      },
    });
  }

  /**
   * @param {ClientReferralPayoutTO} payoutTO
   */
  payClientReferrals(payoutTO) {
    if (!(payoutTO instanceof ClientReferralPayoutTO)) {
      throw new Error("'payoutTO' must be an instance of 'ClientReferralPayoutTO'");
    }

    return this.api.post('payClientReferrals', payoutTO);
  }

  /**
   *
   * @param {ClientReferralPayoutTO} payoutTO
   * @param {string} accessToken
   */
  payClientReferralsWithApproval(payoutTO, accessToken) {
    if (!(payoutTO instanceof ClientReferralPayoutTO)) {
      throw new Error("'payoutTO' must be an instance of 'ClientReferralPayoutTO'");
    }
    return this.api.post('payClientReferrals', payoutTO, {
      headers: {
        Authorization: `Bearer ${accessToken.token}`,
      },
    });
  }

  getGridData(params) {
    return this.api.post('gridData', params);
  }

  changeOffice(id, officeId) {
    return this.api.post(`${id}/changeOffice/${officeId}`);
  }

  override(referral) {
    return this.api.post(`${referral.id}/override`, referral);
  }

  getTally(officeId) {
    return this.api.get('tally', {
      params: {
        officeId,
      },
    });
  }

  remove(referralId) {
    return this.api.get(`${referralId}/remove`);
  }
}

const apiInstance = new ReferralApi();
export { ReferralApi, apiInstance };
export default apiInstance;
